export default __webpack_public_path__ + "static/media/ENO_BREATHE_LOGOTYPE_POS_AW-FINAL.faddd895.svg";